export enum Environment {
    develop = 'develop',
    'develop-test' = 'develop-test',
    local = 'local',
    stage = 'stage',
    'stage-test' = 'stage-test',
    prod = 'prod',
}
